export const AddressCoordinatesConstants = {
	ManualAddress: {
		lat: 91,
		lng: 181,
	},
};
